@import 'styles/mixins';
@import 'styles/blaze/mixins';

.reelOrShortLoadingPreview {
  border-radius: 20px;
  border: 1px solid var(--dark-8);
  box-shadow: 0px 20px 80px 0px var(--dark-10);
  display: flex;
  flex-direction: column;
  min-width: 346px;
  overflow: hidden;

  .body {
    @include blur(5px);
    height: 100%;
    opacity: 0.4;
    background: linear-gradient(180deg, var(--light-100) 0%, var(--brand-kit-color) 100%);
  }

  .footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 12px 12px 26px 12px;
    gap: 13px;
    width: 100%;
    background: color-mix(in srgb, var(--brand-kit-color) 40%, transparent);
    position: relative;

    .loader {
      position: absolute;
      bottom: 0;
      height: 10px;
      background: var(--dark-4);
      width: 100%;
      left: 0;
    }

    .loaderFull {
      position: absolute;
      bottom: 0;
      height: 10px;
      background: var(--dark-4);
      width: 130px;
      left: 0;
    }

    .row {
      display: flex;
      align-items: center;
      gap: 5px;

      .second {
        :global .ant-skeleton {
          .ant-skeleton-paragraph {
            li {
              border-radius: 90px;
              height: 10px !important;
              margin-top: 0 !important;

              &:last-child {
                margin-top: 0 !important;
                width: 64px !important;
                height: 20px !important;
              }
            }
          }
        }
      }
    }

    :global .ant-skeleton {
      .ant-skeleton-paragraph {
        li {
          border-radius: 90px;
          height: 10px !important;
          margin-top: 0 !important;

          &:last-child {
            margin-top: 12px !important;
            width: 215px !important;
          }
        }
      }
    }

    :global .ant-skeleton-with-avatar {
      width: 100px;

      .ant-skeleton-header {
        padding-right: 5px !important;
      }

      .ant-skeleton-content {
        .ant-skeleton-paragraph li {
          border-radius: 90px;
          margin-top: 12px !important;
          height: 10px;
          width: 98px !important;
        }
      }
    }

    :global {
      span,
      li {
        background-image: linear-gradient(135deg, var(--dark-4) 25%, var(--dark-20) 37%, var(--dark-4) 63%) !important;
      }
    }
  }
}
